var _rect, _g, _rect2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowcaseBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 542 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10_50",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 349,
    height: 292
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 349,
    height: 292,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10_50)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.653 1.06449e-06C309.652 43.5003 285.405 83.2127 261.052 127.467C226.83 189.663 217.088 289.618 210.781 292.204C206.815 293.83 177.357 263.767 150.894 209.911C135 177.601 123.182 135.504 110.356 89.8726C99.308 50.5845 83.5264 20.4054 64.4353 5.0174e-06C35.6393 -30.7785 -0.685893 -39.3205 -39.6526 -23.3445C-86.7517 -4.03439 -22.3851 50.5486 -5.7163e-07 104C-5.7163e-07 104 -35.8205 165.923 -3.99177e-06 179.52C55.5294 200.6 114.819 200.257 115.728 203.914C116.635 207.356 58.6561 215.013 -6.2752e-06 199.426C-43.9493 187.746 -88.2787 163.018 -108.503 113.689C-132.662 54.7636 -111.649 -16.4804 -43.7416 -44.3659C-43.7416 -44.3659 52.638 -48.7214 89.4243 1.48757e-06C105.721 21.5842 119.568 49.7868 129.69 84.5529C153.812 167.458 182.623 182.526 194.282 177.747C205.927 172.972 219.398 156.255 241.841 117.698C259.39 87.4689 287.835 50.1168 287.764 -2.68806e-05L311.653 1.06449e-06Z",
    fill: "white",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10_50",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 555,
    width: 444,
    height: 277
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 555,
    width: 444,
    height: 277,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10_50)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.858 616.903C330.231 613.946 359.732 554.185 432.23 555.167C498.741 556.093 541.603 615.54 541.603 676.991C541.603 749.78 489.951 786.113 434.706 830.664C379.448 875.229 332.517 964.018 325.7 964.018C321.414 964.018 305.562 925.027 301.507 865.158C299.058 829.233 304.092 785.8 309.535 738.714C321.278 637.019 283.723 577.054 213.687 577.054C162.783 577.054 121.54 620.392 121.976 678.34C122.751 784.082 272.143 840.136 271.245 846.269C270.428 852.442 98.0001 802.194 98.0001 677.727C98.0001 614.041 144.468 556.093 217.878 556.052C291.37 555.998 341.893 623.84 329.442 741.126C320.312 826.984 341.253 851.856 353.853 851.856C366.44 851.856 385.245 841.499 420.637 814.337C456.015 787.121 512.239 755.899 517.832 678.667C521.138 632.603 488.4 573.824 429.345 573.824C362.221 573.824 339.457 619.86 334.858 616.903Z",
    fill: "white",
    fillOpacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseBackground);
export default __webpack_public_path__ + "static/media/showcaseBackground.dc1f04c34ff253500ab01a5e17d0f68b.svg";
export { ForwardRef as ReactComponent };